<template>
    <div class="content-wrapper">

        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.createCampus')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

              <b-alert
                    v-model="alert"
                    :variant="alertClass"
                    dismissible
                    fade
                    >{{ alertMessage }}</b-alert
                >

                <form role="form" @submit.prevent="submit()">
                    <div class="card">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.setting.createCampus')}}</div>
                            <b-button type="submit" variant="primary" class="float-right">{{$t('button.save')}}
                            </b-button>
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                                <label>{{$t('form.setting.partnerCampusLocation')}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="campus.PartnerCampusLocation" :class="{ 'is-invalid': $v.campus.PartnerCampusLocation.$error }">
                                  <div
                                    class="invalid-feedback"
                                    v-if="!$v.campus.PartnerCampusLocation.required"
                                > {{$t('form.validation.required')}}</div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.partnerCode')}}<span class="text-danger">*</span></label>
                                <v-select label="PartnerCode" :options="partners" v-model="campus.PartnerID"
                                    :reduce="partners => partners.PartnerID" :class="{ 'is-invalid': $v.campus.PartnerID.$error }">
                                </v-select>
                                 <div
                                    class="invalid-feedback"
                                    v-if="!$v.campus.PartnerID.required"
                                > {{$t('form.validation.required')}}</div>
                            </div>

                            <div class="form-group">
                                <label>
                                    <input type="checkbox" v-model="campus.PartnerCampusActive">
                                    {{$t('form.setting.active')}}
                                </label>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.sortOrder')}}</label>
                                <input type="number" class="form-control" v-model="campus.PartnerCampusSortOrder">
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";

    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                campus: {
                    PartnerCampusLocation: '',
                    PartnerID: null,
                    PartnerCampusActive: null,
                    PartnerCampusSortOrder: null,
                },

                partners: []
            }
        },
         validations: {
            campus: {
                PartnerCampusLocation:{required},
                PartnerID:{required}
            }
        },

        mounted() {
            if (!this.permissions.createSettingsCampuses) {
                return this.$router.push('/');
            }

            this.getPartners();
        },

        methods: {

            getPartners() {
                axios
                    .get('/api/partners?full')
                    .then(response => this.partners = response.data)
                    .catch(error => console.log('error fetching partners'));
            },

            submit() {

            this.$v.$touch();

            if (this.$v.$invalid) {
                let errorMsg = "";
                if (this.$v.campus.PartnerCampusLocation.$error) {
                    errorMsg = "Partner Capmus Location";
                }

                if (this.$v.campus.PartnerID.$error) {
                    errorMsg = errorMsg? errorMsg+ " and Partner Code": "Partner Code";
                }

                this.showAlert(
                    this.$t("form.validation.mandatoryFieldsError", {
                        errors: errorMsg
                    }),
                    "danger"
                );
                return;
            }

                this.clearAlert();

                this.isLoading = true;

                axios
                    .post('/api/campuses', this.campus)
                    .then(response => {

                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'CampusIndex'
                                });
                            }, 2000);
                        }

                    }).catch(error => {
                        this.isLoading = false;
                        this.showAlert(error.response.data.message, 'danger');
                    })
            },

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

            clearAlert() {
                this.alert = false;
                this.alertClass = '';
                this.alertMessage = '';
            }
        }
    }

</script>
